export const isPhoneEmpty = (value: string) => value === '+7';
